import { render } from "./MintDescription.vue?vue&type=template&id=ac65b3be"
import script from "./MintDescription.vue?vue&type=script&lang=js"
export * from "./MintDescription.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__